import { l } from '@manychat/manyui'

import { billing } from 'common/billing/billingService/billingService'
import { PaywallDescriptor } from 'common/billing/components/Paywall/interfaces'
import { ChannelType, ChannelTypeLabel } from 'common/core/constants/ChannelType'
import channelsCountImg from 'common/goProExperimentHandlers/assets/channels-count.png'

const title = l.makeTranslate("One trial per account. That's the whole rule.")
const benefitsTitle = l.makeTranslate('Keep the good part going:')
const benefitsItems = [
  l.makeTranslate('Unlimited automations'),
  l.makeTranslate("Automatic follow-ups when there's no reply"),
  l.makeTranslate('Automatic story replies, no limits'),
  l.makeTranslate('Welcome messages for new followers'),
]

/**
 * Copy for the "connect a channel that already had a trial, during an
 * active trial" paywall. The channel name is drilled into `text` at call
 * time via `l.translate` because the Universal paywall's dynamic-placeholder
 * machinery (useContextTranslate) only fills in `{planTitle}` /
 * `{currentPlanTitle}` / `{planPrice}`.
 */
export const getConnectionBlockedActiveTrialPaywall = (channel: ChannelType): PaywallDescriptor =>
  billing.paywalls.universal({
    image: { src: channelsCountImg },
    title,
    text: l.translate(
      "And that's exactly what happened here: your {channel} account already used its trial, but you can start your plan right away.",
      { channel: ChannelTypeLabel[channel] },
    ),
    preheading: '',
    benefits: {
      title: benefitsTitle,
      items: benefitsItems,
    },
  })
